import React, {useEffect, useState} from 'react'
import {Modal, ModalTitle, ParagraphText} from '@thryvlabs/maverick'
import Skeleton from 'react-loading-skeleton'

const DetailsModal = ({
  getData,
  buttonName,
  title,
  onClose,
  meeting_type,
  selectedTimeZone,
  height,
}) => {
  const [data, setData] = useState([])

  useEffect(() => {
    return () => setData([])
  }, [])

  async function fetchData() {
    const fetchedData = await getData()
    setData(fetchedData)
  }

  const LINKS = ['Sales Rep Email', 'Email', 'Website', 'Google Map']
  const DISCOVERY_FIELDS = [
    'Business Opportunity',
    'Current Software Stack',
    'Timeline & Buying Intent',
  ]

  // Helper function to format discovery answers - Enterprise UX
  const formatDiscoveryAnswer = answer => {
    if (!answer || answer === '-') return '-'

    const items = answer
      .split(',')
      .map(item => item.trim())
      .filter(item => item)

    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '8px',
          padding: '10px 0',
        }}
      >
        {items.map((item, index) => (
          <div
            key={index}
            style={{
              display: 'flex',
              alignItems: 'flex-start',
              lineHeight: '1.5',
              padding: '10px 14px',
              backgroundColor: '#f8f9fa',
              borderRadius: '6px',
              borderLeft: '4px solid #ff5000',
              transition: 'all 0.2s ease',
              boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
            }}
          >
            <span
              style={{
                marginRight: '12px',
                flexShrink: 0,
                fontWeight: '700',
                color: '#ff5000',
                fontSize: '16px',
              }}
            >
              •
            </span>
            <span
              style={{
                flex: 1,
                wordBreak: 'break-word',
                color: '#2c3e50',
                fontSize: '14px',
                fontWeight: '500',
              }}
            >
              {item}
            </span>
          </div>
        ))}
      </div>
    )
  }

  return (
    <>
      <style>
        {`
          #details-modal .modal-dialog {
            max-width: 1100px !important;
            width: 90vw !important;
            margin: 1.75rem auto !important;
          }
          #details-modal .modal-content {
            max-width: 100% !important;
            border-radius: 12px !important;
            box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2) !important;
            border: none !important;
          }
          #details-modal .modal-header {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
            color: white !important;
            border-radius: 12px 12px 0 0 !important;
            padding: 1.5rem !important;
            border-bottom: none !important;
          }
          #details-modal .modal-header h2,
          #details-modal .modal-header .modal-title {
            color: white !important;
            margin: 0 !important;
            font-weight: 600 !important;
          }
          #details-modal .modal-header button.close {
            color: white !important;
            opacity: 0.9 !important;
          }
          #details-modal .modal-header button.close:hover {
            opacity: 1 !important;
          }
          #details-modal .modal-body {
            padding: 1.75rem !important;
            background-color: #ffffff !important;
          }
          #details-modal p {
            margin-bottom: 0 !important;
            line-height: 1.5 !important;
          }
          #details-modal .modal-footer {
            border-top: 1px solid #e9ecef !important;
            padding: 1rem 1.5rem !important;
            background-color: #f8f9fa !important;
            border-radius: 0 0 12px 12px !important;
          }
          #details-modal a {
            color: #667eea !important;
            text-decoration: none !important;
            font-weight: 500 !important;
            transition: color 0.2s ease !important;
          }
          #details-modal a:hover {
            color: #764ba2 !important;
            text-decoration: underline !important;
          }
        `}
      </style>
      <Modal
        id="details-modal"
        onOpen={fetchData}
        onClose={onClose}
        variant="default"
        title={title}
        btnText={buttonName}
        btnType="secondary"
        size="xl"
        centered
      >
        {data &&
          data.map(
            ({id, sectionType, sectionName, sectionData, Component}, i) =>
              sectionName === 'Notes' &&
              (meeting_type === 'onboarding' ||
                meeting_type === 'creative consultation' ||
                meeting_type === 'creative' ||
                meeting_type === 'thryv-success-services' ||
                meeting_type === 'thryv success services') ? null : (
                <div key={i} style={{marginBottom: '1.5rem'}}>
                  <ModalTitle
                    variant="subtitle"
                    size="lg"
                    style={{
                      marginBottom: '1rem',
                      color: '#2c3e50',
                      fontWeight: '600',
                      borderBottom: '2px solid #e9ecef',
                      paddingBottom: '0.5rem',
                    }}
                  >
                    {sectionName}
                  </ModalTitle>
                  {sectionType === 'object' &&
                    sectionData &&
                    Object.keys(sectionData).map((prop, i) =>
                      sectionData[prop] === '-' ? null : (
                        <div
                          key={i}
                          style={{
                            display: 'grid',
                            gridTemplateColumns: '180px 1fr',
                            gap: '20px',
                            marginBottom: '0',
                            alignItems: 'center',
                            padding: '2px 0',
                          }}
                        >
                          <div>
                            <ParagraphText
                              variant="reg"
                              style={{
                                fontWeight: '600',
                                marginBottom: '0',
                                lineHeight: '1.4',
                                color: '#495057',
                              }}
                            >
                              {prop}:
                            </ParagraphText>
                          </div>
                          {LINKS.includes(prop) ? (
                            <div style={{lineHeight: '1.4'}}>
                              {prop === 'Sales Rep Email' && (
                                <a
                                  href={`mailto:${sectionData[prop]}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  {sectionData[prop]}
                                </a>
                              )}
                              {prop === 'Email' && (
                                <a
                                  href={`mailto:${sectionData[prop]}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  {sectionData[prop]}
                                </a>
                              )}
                              {prop === 'Google Map' && (
                                <a
                                  href={sectionData[prop]}
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  View Location
                                </a>
                              )}
                              {prop === 'Website' && (
                                <a
                                  href={sectionData[prop]}
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  {sectionData[prop]}
                                </a>
                              )}
                            </div>
                          ) : (
                            <div style={{lineHeight: '1.4'}}>
                              {DISCOVERY_FIELDS.includes(prop) ? (
                                formatDiscoveryAnswer(sectionData[prop])
                              ) : (
                                <ParagraphText
                                  variant="reg"
                                  style={{
                                    marginBottom: '0',
                                    lineHeight: '1.4',
                                    color: '#2c3e50',
                                  }}
                                >
                                  {sectionData[prop]}
                                </ParagraphText>
                              )}
                            </div>
                          )}
                        </div>
                      ),
                    )}
                  {sectionType === 'custom' && Component && <Component />}
                </div>
              ),
          )}
        {!data?.length && <Skeleton height={height} />}
      </Modal>
    </>
  )
}

export {DetailsModal}
